const logoPath = {
  Assurance: "assurance.png",
  Garantie: "garantie.png",
  Constructeur: "constructeur.png",
  Générique: "generique.png",
};

export default logoPath;
